export default function storageProxy() {
    const _setItem = Storage.prototype.setItem;
    const _getItem = Storage.prototype.getItem;
    const _session_setItem = window.sessionStorage.setItem;
    const _session_getItem = window.sessionStorage.getItem;
    const _session_removeItem = window.sessionStorage.removeItem;
    const _local_setItem = window.localStorage.setItem;
    const _local_getItem = window.localStorage.getItem;
    const _local_removeItem = window.localStorage.removeItem;
    const _sessionStorage = window.sessionStorage;
    const _localStorage = window.localStorage;

    try {
        Storage.prototype.setItem = function() {
            try {
                return _setItem.apply(this, arguments);
            } catch (error) {
                return '';
            }
        };

        Storage.prototype.getItem = function() {
            try {
                return _getItem.apply(this, arguments);
            } catch (error) {
                return '';
            }
        };

        Object.defineProperty(window, 'sessionStorage', {
            get: function() {
                return {
                    setItem: function() {
                        try {
                            return _session_setItem.apply(_sessionStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    },

                    getItem: function() {
                        try {
                            return _session_getItem.apply(_sessionStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    },

                    removeItem: function() {
                        try {
                            return _session_removeItem.apply(_sessionStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    }
                };
            }
        });

        Object.defineProperty(window, 'localStorage', {
            get: function() {
                return {
                    setItem: function() {
                        try {
                            return _local_setItem.apply(_localStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    },

                    getItem: function() {
                        try {
                            return _local_getItem.apply(_localStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    },

                    removeItem: function() {
                        try {
                            return _local_removeItem.apply(_localStorage, arguments);
                        } catch (error) {
                            return function() {
                                return '';
                            };
                        }
                    }
                };
            }
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error', e);
    }
}
